import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import { WebhookActions, WebhookState } from '~/store/owner/webhook'

import OwnerDetailMixin from './ownerDetailMixin'

export default defineComponent({
  name: 'WebhookMixin',

  mixins: [OwnerDetailMixin],

  computed: {
    ...(mapState<WebhookState>('owner/webhook', {
      webhookEndpoints: (state: WebhookState) => state.webhookEndpoints,
      endpoint: (state: WebhookState) => state.endpoint,
      delivery: (state: WebhookState) => state.delivery,
      endpointDeliveries: (state: WebhookState) => state.endpointDeliveries,
      endpointDeliveriesCount: (state: WebhookState) => state.endpointDeliveriesCount,
      webhookEventTypes: (state: WebhookState) => state.webhookEventTypes,
      totalWebhookEndpoints: (state: WebhookState) => state.totalWebhookEndpoints
    }) as {
      webhookEndpoints: () => WebhookState['webhookEndpoints']
      endpoint: () => WebhookState['endpoint']
      delivery: () => WebhookState['delivery']
      endpointDeliveries: () => WebhookState['endpointDeliveries']
      endpointDeliveriesCount: () => WebhookState['endpointDeliveriesCount']
      webhookEventTypes: () => WebhookState['webhookEventTypes']
      totalWebhookEndpoints: () => WebhookState['totalWebhookEndpoints']
    })
  },

  methods: {
    ...mapActions('owner/webhook', {
      createEndpoint: WebhookActions.CREATE_ENDPOINT,
      disableEndpoint: WebhookActions.DISABLE_ENDPOINT,
      deleteEndpoint: WebhookActions.DELETE_ENDPOINT,
      testEndpoint: WebhookActions.TEST_ENDPOINT,
      updateEndpoint: WebhookActions.UPDATE_ENDPOINT,
      fetchSingleEndpoint: WebhookActions.FETCH_SINGLE_ENDPOINT,
      fetchSingleDelivery: WebhookActions.FETCH_SINGLE_DELIVERY,
      fetchWebhookEndpoints: WebhookActions.FETCH_WEBHOOK_ENDPOINTS,
      fetchEndpointDeliveries: WebhookActions.FETCH_ENDPOINT_DELIVERIES,
      fetchWebhookEventTypesList: WebhookActions.FETCH_WEBHOOK_EVENT_TYPES_LIST
    }),

    async refetchEndpointList(): Promise<void> {
      const { owner, provider } = this.$route.params
      await this.fetchWebhookEndpoints({
        login: owner,
        limit: 25,
        currentPage: 1,
        provider,
        refetch: true
      })
    },

    validateWebhookForm(
      url: string,
      enableApiSigning: boolean,
      secret: string,
      selectedEvents: unknown[]
    ): void {
      if (!url) {
        throw new Error('Please add a URL for the endpoint.')
      }

      try {
        const parsedURL = new URL(url)
        if (parsedURL.protocol !== 'http:' && parsedURL.protocol !== 'https:') {
          throw new Error('Please enter a valid URL.')
        }
      } catch (_) {
        throw new Error('Please enter a valid URL.')
      }

      if (enableApiSigning) {
        if (!secret) {
          throw new Error('Please add a secret for the endpoint.')
        }

        if (secret.length < 16) {
          throw new Error('The secret should be at least 16 characters.')
        }
      }

      if (selectedEvents.length === 0) {
        throw new Error('Please add at least one event before submitting.')
      }
    }
  }
})
